module.exports = __webpack_public_path__ + "img/go-with-freedom-mobile.ecdb093c.png";